import script from "./TemperatureReportHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TemperatureReportHeader.vue?vue&type=script&setup=true&lang=js"

import "./TemperatureReportHeader.vue?vue&type=style&index=0&id=1723ad04&lang=css"

const __exports__ = script;

export default __exports__